var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotepad = function SvgNotepad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "1 1 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.56 4.47H6.932c-.725 0-1.313-.568-1.313-1.269V1.27C5.62.569 6.207 0 6.932 0h7.628c.725 0 1.313.568 1.313 1.269V3.2c0 .701-.588 1.269-1.313 1.269"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.5,
    d: "M23.382 13.706a2.15 2.15 0 0 0-2.963 0l-.969.94 2.965 2.864.966-.934a1.974 1.974 0 0 0 0-2.87M18.512 15.557l-5.171 4.988a.77.77 0 0 0-.204.394l-.39 2.22c-.089.489.354.909.86.832l2.298-.377a.76.76 0 0 0 .399-.198l5.171-4.997z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.308 2.237h-1.104v.965c0 1.408-1.186 2.554-2.644 2.554H6.932c-1.458 0-2.643-1.146-2.643-2.554v-.965H3.167C1.419 2.237 0 3.61 0 5.297V20.94C0 22.628 1.42 24 3.167 24h8.388a1.9 1.9 0 0 1-.12-1.061l.39-2.215c.069-.392.255-.755.536-1.05l5.645-5.448 1.468-1.426a3.43 3.43 0 0 1 1.999-.931V5.306c.002-1.706-1.409-3.069-3.165-3.069M9.365 14.951H5.516a.785.785 0 0 1-.798-.771c0-.426.358-.772.798-.772h3.85c.44 0 .798.346.798.772a.785.785 0 0 1-.799.771m4.712-4.378h-8.56A.785.785 0 0 1 4.72 9.8c0-.426.357-.771.798-.771h8.56c.44 0 .798.345.798.771a.785.785 0 0 1-.798.772"
  })));
};
export default SvgNotepad;